























































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { TranslateResult } from 'vue-i18n'
import { GridOptions } from '@/types'
import DeleteDialog from '@/components/DeleteDialog.vue'
import ActiveCellRenderer from '@/components/cell-renderer/ActiveCellRenderer.vue'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import AllocationDialog from '@/components/disposition/AllocationDialog.vue'
import {
  DELETE_DISPOSITION_JOB,
  FETCH_DISPOSITION_ADDRESS_LIST,
  FETCH_DISPOSITION_JOB_LIST,
  SET_DISPOSITION_ADDRESS
} from '@/store/action-types'
import { DispositionJob } from '@/model/disposition/DispositionJob'
import { DispositionAddress } from '@/model/disposition/DispositionAddress'
import { GET_DISPOSITION_ADDRESS } from '@/store/getter-types'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { KeyAction } from '@/model/KeyAction'
import { keyActionService } from '@/services/key-action-service'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}
class Search extends KeyAction {}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  showAll: boolean
  addressList: DispositionAddress[]
  dispositionJobList: DispositionJob[]
  gridData: DispositionJob[]
  gridOptions: GridOptions
  gridFrameworkComponents: Object
  overlayNoRowsTemplate: string
  currentSelectedRowId: string
  currentSelectedRowData: DispositionJob | undefined
  showDialog: boolean
  showDeleteDialog: boolean
  dispositionAddress: number | undefined
  gridStyle: string
  showSearchField: boolean
  search: string | null
  loading: boolean

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'Allocation',

  components: {
    AgGridVue,
    DeleteDialog,
    AllocationDialog,
    ProgressCircular
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      showAll: false,
      addressList: [],
      dispositionJobList: [],
      gridData: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('disposition.numberShort'), width: 100, field: 'number' },
          { headerName: this.$t('disposition.address'), width: 500, field: 'address' },
          { headerName: this.$t('disposition.created'), width: 200, field: 'created' },
          { headerName: this.$t('disposition.createdBy'), field: 'createdBy' },
          { headerName: this.$t('disposition.active'), width: 150, field: 'status', cellRenderer: 'activeRenderer' }
        ]
      },
      gridFrameworkComponents: {
        activeRenderer: ActiveCellRenderer
      },
      overlayNoRowsTemplate: '<span>' + this.$t('errors.noRowsToShow') + '</span>',
      currentSelectedRowId: '',
      currentSelectedRowData: undefined,
      showDialog: false,
      showDeleteDialog: false,
      dispositionAddress: undefined,
      gridStyle: '',
      showSearchField: false,
      search: null,
      loading: false,

      keyActions: []
    }
  },

  watch: {},

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isEnableEditButton (): boolean {
      return !!(this.currentSelectedRowData && this.currentSelectedRowData.id)
    },

    isEnableDeleteButton (): boolean {
      return !!(this.currentSelectedRowData && this.currentSelectedRowData.id && this.currentSelectedRowData.status !== 3)
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    setShowButtonIcon (): string {
      if(this.showAll) {
        return 'visibility'
      } else {
        return 'visibility_off'
      }
    },

    isSearchEnabled (): boolean {
      return this.gridData.length > 0
    },

    filteredGridData (): any[] {
      if(this.search) {
        return this.gridData.filter((item: DispositionJob) => {
          return item.address.toLowerCase().includes(this.search!.toLowerCase())
        })
      } else {
        return this.gridData
      }
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | Search | null): boolean {
      if(action instanceof Create) {
        return true
      } else if(action instanceof Edit) {
        return this.isEnableEditButton
      } else if(action instanceof Delete) {
        return this.isEnableDeleteButton
      } else if(action instanceof Search) {
        return this.isSearchEnabled
      } else {
        return false
      }
    },

    onResize (): void {
      const height: number = window.innerHeight - 72 - 24 - 48
      this.gridStyle = `width: 100%; height: 100%; min-height: ${height}px`
    },

    onShowDispositionJobs (): void {
      this.currentSelectedRowId = ''
      this.currentSelectedRowData = undefined
      this.showAll = !this.showAll

      if(this.showAll) {
        this.gridData = _.cloneDeep(this.dispositionJobList)
      } else {
        this.gridData = this.dispositionJobList.filter((item: DispositionJob) => item.status !== 3)
      }
    },

    onRowClicked (params: any): void {
      this.currentSelectedRowId = params.node.data.id
      this.currentSelectedRowData = this.gridData.find((item: DispositionJob) => item.id === parseInt(this.currentSelectedRowId))
    },

    onAddDispositionClick (): void {
      this.currentSelectedRowData = undefined
      this.showDialog = true
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddDispositionClick()
    },

    onEditDispositionButtonClick (): void {
      this.showDialog = true
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditDispositionButtonClick()
    },

    dialogSaved (): void {
      this.closeDialog()
    },

    closeDialog (): void {
      this.dispositionAddress = undefined
      this.currentSelectedRowId = ''
      this.currentSelectedRowData = undefined
      this.fetchData()
      this.showDialog = false
    },

    onDeleteDispositionButtonClick (): void {
      this.showDeleteDialog = true
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteDispositionButtonClick()
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      if(this.currentSelectedRowData && this.currentSelectedRowData.personalDispositionJobDetailId) {
        this.deleteDispositionJob(this.currentSelectedRowData.personalDispositionJobDetailId)
      }
    },

    async deleteDispositionJob (payload: number): Promise<void> {
      try {
        let response: boolean = await this.$store.dispatch(DELETE_DISPOSITION_JOB, payload)
        if(response) {
          this.onDeleteDialogClose()
          this.fetchData()
          this.currentSelectedRowId = ''
          this.currentSelectedRowData = undefined
          this.messageSnackbar = this.$t('success.dataHaveBeenDeleted')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.currentSelectedRowId = ''
          this.currentSelectedRowData = undefined
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (): Promise<void> {
      this.loading = true
      try {
        this.dispositionJobList = await this.$store.dispatch(FETCH_DISPOSITION_JOB_LIST, false)

        if (this.showAll) {
          this.gridData = this.dispositionJobList
        } else {
          this.gridData = this.dispositionJobList.filter((item: DispositionJob) => item.status !== 3)
        }
      } catch {

      } finally {
        this.loading = false
      }
    },

    async fetchAddressList (): Promise<void> {
      this.loading = true
      try {
        this.addressList = await this.$store.dispatch(FETCH_DISPOSITION_ADDRESS_LIST)
        if(this.dispositionAddress && this.addressList) {
          const foundAddress: DispositionAddress | undefined = this.addressList.find((item: DispositionAddress) => item.id === this.dispositionAddress)
          if(foundAddress) {
            this.showDialog = true
          } else {
            this.dispositionAddress = undefined
          }
        } else {
          this.dispositionAddress = undefined
        }
      } catch {

      } finally {
        this.loading = false
      }
    },

    onSearchButtonClick (): void {
      this.showSearchField = !this.showSearchField
      if(!this.showSearchField) {
        this.search = null
      }
    },

    searchClick (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      this.onSearchButtonClick()
    },
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
      new Search(KeyActionEnum.search, this.searchClick, this.resolver, null)
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
    this.dispositionAddress = this.$store.getters[GET_DISPOSITION_ADDRESS]
    this.$store.dispatch(SET_DISPOSITION_ADDRESS, undefined)
    this.fetchData()
    this.fetchAddressList()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
